import { Routes } from '@angular/router';
import { LogoutComponent } from './logout.component';

export const LOGOUT_ROUTES: Routes = [
    {
        path: 'logout',
        component: LogoutComponent
    }
];
